// Monta el orquestador de vuelta del TPV (ver tpvResume.js).
import { useEffect } from "react";
import { useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import { mountTpvResume, setResumeHistory } from "./tpvResume";

export default function useTpvResume() {
  const store = useStore();
  const history = useHistory();
  useEffect(() => mountTpvResume(store.dispatch, store.getState), [store]);
  // Para volver al plano si la mesa se cerró en otro dispositivo mientras no estaba.
  useEffect(() => setResumeHistory(history), [history]);
}
